/**
 * Build a browser-loadable src for a stored branding logo URL.
 *
 * On dev/prod, logos live in object storage (GCS) and the stored URL is already
 * absolute and correct — return it untouched. Only a LOCAL disk logo (served by
 * the API on localhost) gets its host rewritten to the configured API base, so
 * the app loads it from the API the frontend is actually pointed at (and so the
 * admin app on a different port can reach it).
 */
export function toBrandingLogoSrc(logoUrl) {
    if (!logoUrl || typeof logoUrl !== 'string') return null;

    const apiBase = (process.env.REACT_APP_MYDQ_API || '').replace(/\/v1\/?$/, '');

    try {
        const u = new URL(logoUrl);
        const isLocalDisk = u.hostname === 'localhost' || u.hostname === '127.0.0.1';
        // Absolute URL from object storage / any real host → use as-is.
        if (!isLocalDisk) return logoUrl;
        return apiBase ? `${apiBase}${u.pathname}` : logoUrl;
    } catch {
        // Relative path → prefix with the configured API base when available.
        if (apiBase && logoUrl.startsWith('/')) return `${apiBase}${logoUrl}`;
        return logoUrl;
    }
}

export default toBrandingLogoSrc;
